import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const TriangleIcon = ({ className, fill }) => (
  <SvgIcon viewBox='0 0 8.315 5.21' className={className}>
    <path id='Path_1157' data-name='Path 1157' d='M8.315,0,4.157,5.21,0,0Z' style={{ fill }} />
  </SvgIcon>
);

export default TriangleIcon;
